<template>
  <div>
    <el-form
      ref="scheduleForm"
      v-loading="isLoading"
      :rules="rules"
      :model="schedule"
      size="small"
    >
      <el-row :gutter="15">
        <el-col :md="12">
          <el-form-item
            label="Active From"
            prop="date_from"
          >
            <el-date-picker
              v-model="schedule.date_from"
              type="date"
              format="dd/MM/yyyy"
              value-format="yyyy-MM-dd HH:mm"
              placeholder="Pick a date"
              clearable
              class="w-100"
            />
          </el-form-item>
        </el-col>
        <el-col :md="12">
          <el-form-item
            label="Active To"
            prop="date_to"
          >
            <el-date-picker
              v-model="schedule.date_to"
              type="date"
              format="dd/MM/yyyy"
              value-format="yyyy-MM-dd HH:mm"
              placeholder="Pick a date"
              clearable
              class="w-100"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- Monday -->
      <el-row :gutter="15">
        <el-col :md="8">
          <el-form-item
            label="Monday Ready Time"
            prop="monday_ready_time"
          >
            <el-time-picker
              v-model="schedule.monday_ready_time"
              placeholder="Monday Ready Time"
              class="w-100"
              value-format="HH:mm"
              :picker-options="{ format: 'HH:mm' }"
            />
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-form-item
            label="Monday Open Time"
            prop="monday_open_time"
          >
            <el-time-picker
              v-model="schedule.monday_open_time"
              placeholder="Monday Open Time"
              class="w-100"
              value-format="HH:mm"
              :picker-options="{ format: 'HH:mm' }"
            />
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-form-item
            label="Monday Closing Time"
            prop="monday_closing_time"
          >
            <el-time-picker
              v-model="schedule.monday_closing_time"
              placeholder="Monday Closing Time"
              class="w-100"
              value-format="HH:mm"
              :picker-options="{ format: 'HH:mm' }"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- Tuesday -->
      <el-row :gutter="15">
        <el-col :md="8">
          <el-form-item
            label="Tuesday Ready Time"
            prop="tuesday_ready_time"
          >
            <el-time-picker
              v-model="schedule.tuesday_ready_time"
              placeholder="Tuesday Ready Time"
              class="w-100"
              value-format="HH:mm"
              :picker-options="{ format: 'HH:mm' }"
            />
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-form-item
            label="Tuesday Open Time"
            prop="tuesday_open_time"
          >
            <el-time-picker
              v-model="schedule.tuesday_open_time"
              placeholder="Tuesday Open Time"
              class="w-100"
              value-format="HH:mm"
              :picker-options="{ format: 'HH:mm' }"
            />
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-form-item
            label="Tuesday Closing Time"
            prop="tuesday_closing_time"
          >
            <el-time-picker
              v-model="schedule.tuesday_closing_time"
              placeholder="Tuesday Closing Time"
              class="w-100"
              value-format="HH:mm"
              :picker-options="{ format: 'HH:mm' }"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- Wednesday -->
      <el-row :gutter="15">
        <el-col :md="8">
          <el-form-item
            label="Wednesday Ready Time"
            prop="wednesday_ready_time"
          >
            <el-time-picker
              v-model="schedule.wednesday_ready_time"
              placeholder="Wednesday Ready Time"
              class="w-100"
              value-format="HH:mm"
              :picker-options="{ format: 'HH:mm' }"
            />
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-form-item
            label="Wednesday Open Time"
            prop="wednesday_open_time"
          >
            <el-time-picker
              v-model="schedule.wednesday_open_time"
              placeholder="Wednesday Open Time"
              class="w-100"
              value-format="HH:mm"
              :picker-options="{ format: 'HH:mm' }"
            />
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-form-item
            label="Wednesday Closing Time"
            prop="wednesday_closing_time"
          >
            <el-time-picker
              v-model="schedule.wednesday_closing_time"
              placeholder="Wednesday Closing Time"
              class="w-100"
              value-format="HH:mm"
              :picker-options="{ format: 'HH:mm' }"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- Thursday -->
      <el-row :gutter="15">
        <el-col :md="8">
          <el-form-item
            label="Thursday Ready Time"
            prop="thursday_ready_time"
          >
            <el-time-picker
              v-model="schedule.thursday_ready_time"
              placeholder="Thursday Ready Time"
              class="w-100"
              value-format="HH:mm"
              :picker-options="{ format: 'HH:mm' }"
            />
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-form-item
            label="Thursday Open Time"
            prop="thursday_open_time"
          >
            <el-time-picker
              v-model="schedule.thursday_open_time"
              placeholder="Thursday Open Time"
              class="w-100"
              value-format="HH:mm"
              :picker-options="{ format: 'HH:mm' }"
            />
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-form-item
            label="Thursday Closing Time"
            prop="thursday_closing_time"
          >
            <el-time-picker
              v-model="schedule.thursday_closing_time"
              placeholder="Thursday Closing Time"
              class="w-100"
              value-format="HH:mm"
              :picker-options="{ format: 'HH:mm' }"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- Friday -->
      <el-row :gutter="15">
        <el-col :md="8">
          <el-form-item
            label="Friday Ready Time"
            prop="friday_ready_time"
          >
            <el-time-picker
              v-model="schedule.friday_ready_time"
              placeholder="Friday Ready Time"
              class="w-100"
              value-format="HH:mm"
              :picker-options="{ format: 'HH:mm' }"
            />
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-form-item
            label="Friday Open Time"
            prop="friday_open_time"
          >
            <el-time-picker
              v-model="schedule.friday_open_time"
              placeholder="Friday Open Time"
              class="w-100"
              value-format="HH:mm"
              :picker-options="{ format: 'HH:mm' }"
            />
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-form-item
            label="Friday Closing Time"
            prop="friday_closing_time"
          >
            <el-time-picker
              v-model="schedule.friday_closing_time"
              placeholder="Friday Closing Time"
              class="w-100"
              value-format="HH:mm"
              :picker-options="{ format: 'HH:mm' }"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- Saturday -->
      <el-row :gutter="15">
        <el-col :md="8">
          <el-form-item
            label="Saturday Ready Time"
            prop="saturday_ready_time"
          >
            <el-time-picker
              v-model="schedule.saturday_ready_time"
              placeholder="Saturday Ready Time"
              class="w-100"
              value-format="HH:mm"
              :picker-options="{ format: 'HH:mm' }"
            />
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-form-item
            label="Saturday Open Time"
            prop="saturday_open_time"
          >
            <el-time-picker
              v-model="schedule.saturday_open_time"
              placeholder="Saturday Open Time"
              class="w-100"
              value-format="HH:mm"
              :picker-options="{ format: 'HH:mm' }"
            />
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-form-item
            label="Saturday Closing Time"
            prop="saturday_closing_time"
          >
            <el-time-picker
              v-model="schedule.saturday_closing_time"
              placeholder="Saturday Closing Time"
              class="w-100"
              value-format="HH:mm"
              :picker-options="{ format: 'HH:mm' }"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- Sunday -->
      <el-row :gutter="15">
        <el-col :md="8">
          <el-form-item
            label="Sunday Ready Time"
            prop="sunday_ready_time"
          >
            <el-time-picker
              v-model="schedule.sunday_ready_time"
              placeholder="Sunday Ready Time"
              class="w-100"
              value-format="HH:mm"
              :picker-options="{ format: 'HH:mm' }"
            />
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-form-item
            label="Sunday Open Time"
            prop="sunday_open_time"
          >
            <el-time-picker
              v-model="schedule.sunday_open_time"
              placeholder="Sunday Open Time"
              class="w-100"
              value-format="HH:mm"
              :picker-options="{ format: 'HH:mm' }"
            />
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-form-item
            label="Sunday Closing Time"
            prop="sunday_closing_time"
          >
            <el-time-picker
              v-model="schedule.sunday_closing_time"
              placeholder="Sunday Closing Time"
              class="w-100"
              value-format="HH:mm"
              :picker-options="{ format: 'HH:mm' }"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="action-button">
      <el-button
        type="primary"
        size="small"
        @click.native="schedule.id ? save() : create()"
      >
        {{ schedule.id ? 'Save Schedule' : 'Create Schedule' }}
      </el-button>
    </div>
    <br>
  </div>
</template>

<script>
export default {
  props: {
    schedule: {
      type: Object,
      required: true
    }
  },
  data () {
    const validateMondayReady = (rule, value, callback) => {
      if (this.schedule.monday_open_time || this.schedule.monday_closing_time) {
        if (!value) {
          return callback(new Error('Monday Ready Time is required'))
        } else { callback() }
      } else { callback() }
    }
    const validateTuesdayReady = (rule, value, callback) => {
      if (this.schedule.tuesday_open_time || this.schedule.tuesday_closing_time) {
        if (!value) {
          return callback(new Error('Tuesday Ready Time is required'))
        } else { callback() }
      } else { callback() }
    }
    const validateWednesdayReady = (rule, value, callback) => {
      if (this.schedule.wednesday_open_time || this.schedule.wednesday_closing_time) {
        if (!value) {
          return callback(new Error('Wednesday Ready Time is required'))
        } else { callback() }
      } else { callback() }
    }
    const validateThursdayReady = (rule, value, callback) => {
      if (this.schedule.thursday_open_time || this.schedule.thursday_closing_time) {
        if (!value) {
          return callback(new Error('Thursday Ready Time is required'))
        } else { callback() }
      } else { callback() }
    }
    const validateFridayReady = (rule, value, callback) => {
      if (this.schedule.friday_open_time || this.schedule.friday_closing_time) {
        if (!value) {
          return callback(new Error('Friday Ready Time is required'))
        } else { callback() }
      } else { callback() }
    }
    const validateSaturdayReady = (rule, value, callback) => {
      if (this.schedule.saturday_open_time || this.schedule.saturday_closing_time) {
        if (!value) {
          return callback(new Error('Saturday Ready Time is required'))
        } else { callback() }
      } else { callback() }
    }
    const validateSundayReady = (rule, value, callback) => {
      if (this.schedule.sunday_open_time || this.schedule.sunday_closing_time) {
        if (!value) {
          return callback(new Error('Sunday Ready Time is required'))
        } else { callback() }
      } else { callback() }
    }
    return {
      isLoading: false,
      rules: {
        date_from: [
          { required: true, message: 'Active From is required', trigger: ['blur', 'change'] }
        ],
        monday_ready_time: [
          { validator: validateMondayReady, trigger: ['blur', 'change'] }
        ],
        tuesday_ready_time: [
          { validator: validateTuesdayReady, trigger: ['blur', 'change'] }
        ],
        wednesday_ready_time: [
          { validator: validateWednesdayReady, trigger: ['blur', 'change'] }
        ],
        thursday_ready_time: [
          { validator: validateThursdayReady, trigger: ['blur', 'change'] }
        ],
        friday_ready_time: [
          { validator: validateFridayReady, trigger: ['blur', 'change'] }
        ],
        saturday_ready_time: [
          { validator: validateSaturdayReady, trigger: ['blur', 'change'] }
        ],
        sunday_ready_time: [
          { validator: validateSundayReady, trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  methods: {
    create () {
      this.$refs.scheduleForm.validate((valid) => {
        if (valid) {
          this.isLoading = true
          this.$sdk.scheduledpickup.create(this.schedule, builder => {})
            .then(res => {
              this.$emit('updatedSchedule', res)
              this.$message({ message: 'Successfully saved', type: 'success' })
            })
            .finally(() => { this.isLoading = false })
        }
      })
    },
    save () {
      this.$refs.scheduleForm.validate((valid) => {
        if (valid) {
          this.isLoading = true
          let tempSchedule = this.schedule.clone()
          tempSchedule.skips = undefined
          tempSchedule.template = undefined
          tempSchedule.update()
            .then(res => {
              this.$emit('updatedSchedule', res)
              this.$message({ message: 'Successfully saved', type: 'success' })
            })
            .finally(() => { this.isLoading = false })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.action-button {
  float: right;
}
</style>
